"use client";

import { useEffect } from "react";
import clarity from "@microsoft/clarity";

const CLARITY_PROJECT_ID = "stozhilkm0";

export default function Clarity() {
  useEffect(() => {
    // Initialize Microsoft Clarity
    clarity.init(CLARITY_PROJECT_ID);
  }, []);

  return null;
}
